<template>
  <nuxt-link
    :to="$sbLinkFix(blok.link)"
    :target="$sbLinkTarget(blok.link)"
    class="Button btn inline-flex"
    :class="[blok.type, blok.theme]"
  >
    <div>
      {{ blok.text }}
    </div>
  </nuxt-link>
</template>
<script setup lang="ts">

import { ButtonTheme, ButtonType, StoryBlokLink, StoryBlokPropBase } from '#constants/types/storyblok';

type Props = StoryBlokPropBase & {
  link: StoryBlokLink;
  text: string;
  theme: ButtonTheme;
  type: ButtonType;
}

defineProps<{
  blok: Props,
}>();
</script>
